import type { ReactNode } from 'react';
import { SquareArrowOutUpRight } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

/** Ugyanaz a kártya mint a Deal kereső részletezőben */
export const SEARCH_DETAIL_CARD_CLASS =
  'rounded-lg border border-border bg-card p-5 text-sm motion-reduce:animate-none';

export function SearchDetailShell({
  title,
  subtitle,
  meta,
  headerStart,
  tabs,
  onOpenFullPage,
  openFullPageTitle,
  openFullPageDisabled = false,
  children,
  contentClassName,
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  meta?: ReactNode;
  headerStart?: ReactNode;
  tabs?: ReactNode;
  onOpenFullPage: () => void;
  openFullPageTitle: string;
  /** Ha nincs cél URL (pl. jegyzet deal nélkül), a gomb letiltva marad. */
  openFullPageDisabled?: boolean;
  children: ReactNode;
  contentClassName?: string;
}) {
  return (
    <div className="flex h-full min-h-0 flex-col bg-background" data-search-detail-panel>
      <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
        <div className="flex min-h-0 flex-1 flex-col overflow-y-auto overscroll-contain">
          <div className="sticky top-0 z-20 border-b border-border bg-background/95 shadow-sm backdrop-blur supports-[backdrop-filter]:bg-background/90">
            <div className="bg-background p-5 sm:p-6">
              <div className="mb-5 flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between sm:gap-6">
                <div className="flex min-w-0 flex-1 items-start gap-4">
                  {headerStart}
                  <div className="min-w-0 flex-1">
                    {title}
                    {subtitle ? <div className="mt-1.5 text-xs text-muted-foreground">{subtitle}</div> : null}
                  </div>
                </div>
                <Button
                  type="button"
                  variant="outline"
                  size="icon"
                  className="h-9 w-9 shrink-0 sm:h-10 sm:w-10"
                  onClick={onOpenFullPage}
                  title={openFullPageTitle}
                  aria-label={openFullPageTitle}
                  disabled={openFullPageDisabled}
                >
                  <SquareArrowOutUpRight className="h-4 w-4 shrink-0" aria-hidden />
                </Button>
              </div>
              {meta ? (
                <div className="mb-4 space-y-2 text-sm text-foreground/70">{meta}</div>
              ) : null}
            </div>
            {tabs}
          </div>
          <div
            className={cn(
              'mx-auto w-full max-w-2xl flex-1 space-y-6 p-5 sm:p-6',
              contentClassName,
            )}
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
